<template>
  <el-dialog
    :title="JSON.stringify(this.selectInstanceRow) != '{}' ? '编辑医生案例':'添加医生案例'"
    :visible="showDoctorInstance"
    width="670px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div class="add-instance-dialog">
      <el-form ref="instanceForm" :model="addinstanceForm" :rules="formRules" label-width="96px">
        <el-form-item label="案例图片：" prop="caseUrl">
          <div>
            <BaseUploadFile :fileSize="10" :isShowTip="false" :fileType="['png', 'jpg', 'jpeg']"
                :size="100" :height="150" :responseFn="handleMessageResponse" :action="VUE_APP_WECHATBASE_URL"
                :data="{ path:'dsicm-doctor', type: 'image', mediaId: '' }" v-model="addinstanceForm.caseUrl"></BaseUploadFile>
            <div style="color: #999999;">请尽量上传竖版图片，图片大小不超过10M，建议格式PNG、JPG、JPEG</div>
          </div>
        </el-form-item>
        <el-form-item label="案例文本：" prop="caseText">
          <el-input type="textarea" maxlength="150" :autosize="{ minRows: 5, maxRows: 20 }" show-word-limit placeholder="请输入案例文本" v-model="addinstanceForm.caseText"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" type="primary" @click="saveinstanceForm">确 认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {
  addInstanceData,
  updateInstanceData
} from "@/api/doctorTeam.js";

import local from "@/utils/local.js";
import { DEEP_CLONE } from '@/utils/constants'
export default {
  props: {
    teamId: {
      type: String,
      default: ''
    },
    planinstanceTitle: {
      type: String
    },
    showDoctorInstance: {
      type: Boolean,
      default: false
    },
    selectInstanceRow:{
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      address: sessionStorage.getItem("ADDRESS"),
      VUE_APP_WECHATBASE_URL: '/api/dsicm-contact-platform/feign/file/upload',
      headers: {
        Authorization: localStorage.getItem('Authorization'),
      },
      imgPath: process.env.VUE_APP_OSS_URL,
      addinstanceForm: {
        caseText:'',
        caseUrl: ''
      },
      formRules: {
        caseUrl:[{ required: true, message: '此项为必填项', trigger: ['change', 'blur'] }],
        caseText:[{ required: true, message: '此项为必填项', trigger: ['change', 'blur'] }]
      }
    }
  },
  async created() {
    if (JSON.stringify(this.selectInstanceRow) != '{}') {
      this.addinstanceForm = DEEP_CLONE(this.selectInstanceRow)
      this.addinstanceForm.caseText = this.$getEditorText(this.addinstanceForm.caseText)
    }
  },
  mounted() {},
  methods: {
    handleMessageResponse(response, file, fileList) {
      let url;
      if (response.code == 0) {
        url = this.imgPath + response.data;
      }
      return url;
    },
    handleChange(file) {
      this.addinstanceForm.imageUrl = file.data
      // this.checkFormData.pictureUrl = file.data
      this.$forceUpdate()
      this.$message.success('上传成功')
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg'
      // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt5M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
      }
      return isJPG && isLt5M
    },
    async saveinstanceForm() {
      if (this.addinstanceForm.caseText.length < 20) {
        this.$message.error('案例文本最少20个字符!')
        return
      }
      this.$refs.instanceForm.validate(async (valid) => {
        if (valid) {
          // 保存时caseText转换
          if (this.addinstanceForm.caseText.match(/^[ ]*$/)) {
            this.addinstanceForm.caseText = this.addinstanceForm.caseText.replace(/\s+/g, '')
            return
          }
          this.addinstanceForm.caseText = this.$setEditorText(this.addinstanceForm.caseText)

          if (this.selectInstanceRow.id) {
            // 修改
            // let res = await updateInstanceData({...this.addinstanceForm,doctorTeamId:this.teamId,id:this.selectInstanceRow.id})
            // if (res.code == 0) {
            //   this.$emit('receiveInstance')
            //   this.$emit('update:showDoctorInstance',false)
            // }
            updateInstanceData({...this.addinstanceForm,doctorTeamId:this.teamId,id:this.selectInstanceRow.id})
              .then(res => {
                if (res.code == 0) {
                  this.$emit('receiveInstance')
                  this.$emit('update:showDoctorInstance',false)
                }
              })
              .catch(err => {
                this.$emit('update:showDoctorInstance',false)
              })
          } else {
            // 新增
            if (this.teamId) {
              // let res = await addInstanceData({...this.addinstanceForm,doctorTeamId:this.teamId})
              // if (res.code == 0) {
              //   this.$emit('receiveInstance')
              //   this.$emit('update:showDoctorInstance',false)
              // }

              addInstanceData({...this.addinstanceForm,doctorTeamId:this.teamId})
                .then(res => {
                  if (res.code == 0) {
                    this.$emit('receiveInstance')
                    this.$emit('update:showDoctorInstance',false)
                  }
                })
                .catch(err => {
                  this.$emit('update:showDoctorInstance',false)
                })
            } else {
              this.$emit('receiveInstance',this.addinstanceForm)
              this.$emit('update:showDoctorInstance',false)
            }
          }
        } else {
          return false
        }
      })
    },
    cancelinstanceForm() {},
    handleClose() {
      this.$emit('update:showDoctorInstance',false)
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-dialog__footer {
  text-align: center;
}
/deep/.el-textarea .el-input__count {
  height: 20px;
  line-height: 20px;
}
</style>
